import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import styles from './styles.scss';


import { messageRead } from '@/services/myself';

export default (props) => {

  const message = props.location.state.message;

  useEffect(()=>{
    messageRead({id:message.id}).then(res => {

    });
  },[]);


  return(
    <Page transition={true} ptr={false} infiniteLoader={false}>

      <div className={styles.detailHeader}>{message.title}</div>

      <div className={styles.detailContent}>{message.content}</div>

    </Page>
  )
}
